import Emitter from "es6-event-emitter";
import * as analyticsEvents from "./analyticsevents";

export default class AnalyticsManagerBase extends Emitter {
  constructor(options = {}, appAnalyticOptions = {}) {
    super();
    this._events = analyticsEvents;
    this._options = options;
    this.cmpManager = null;
    this._appAnalyticOptions = appAnalyticOptions;
  }

  handleEvent(eventType, appState) {
    // TODO handle some error handling on the event here
    this.trigger(eventType, appState);
  }

  // This function is to be overwritten in the clients analyticsmanager
  // returning undefined will result in no modification of the enrichment url
  checkEnrichmentUrl() {
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/common/analytics/analyticsmanagerbase.js